export const UPDATE_LOAD = "UPDATE_LOAD"
export const RESET_LOAD = "RESET_LOAD"
export const UPDATE_STOP = "UPDATE_STOP"
export const RESET_STOP = "RESET_STOP"
export const UPDATE_EVIDENCE = "UPDATE_EVIDENCE"
export const RESET_EVIDENCE = "RESET_EVIDENCE"